import { render, staticRenderFns } from "./supply_review.vue?vue&type=template&id=06daccd2&scoped=true"
import script from "./supply_review.vue?vue&type=script&lang=ts"
export * from "./supply_review.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06daccd2",
  null
  
)

export default component.exports